import React from 'react';

import {parseHTML} from 'polyphony/html';
import {withExplicitProps} from 'polyphony/hoc';
import {BLOCK_CLASS} from 'polyphony/gutenberg/implementation';

const PostBody = withExplicitProps(({children}) => {
    const blocks = polyphony.hooks.useSelector(s => s.blocks);
    return parseHTML(children, (node, forestToReact) => {
        const {tag, attributes, children} = node;
        const {class: className, 'data-block-slug': slug, 'data-props': propJson} = attributes || {};
        if (tag === 'div' && className && className.split(/\s+/).includes(BLOCK_CLASS)) {
            // FIXME: child theme blocks cause crashes -> Race condition
            if (!blocks[slug]) return null; // THIS IS THE FIX, but it hides a race
            return React.createElement(blocks[slug], {
                ...JSON.parse(propJson || "{}"),
                gutenberg: {
                    isEditor: false,
                    setProp: () => {}
                }
            }, forestToReact(children));
        }
        return node;
    });
}, ['children']);

PostBody.displayName = 'PostBody';

export default PostBody;

